export enum TransferState {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  FAILED = 'failed',
  COMPLETED = 'completed',
  CANCELED = 'canceled',
}
